import React, { memo, FC, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { useRedux } from "src/shared/hooks";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import userService from "src/shared/services/user.service";

import { IRootState } from "src/shared/types";
import { loginAction, LoginActionPayload } from "src/store/login";
import OAuthService from "./oauth.service";
import StopwatchSvg from "src/assets/stopwatch.svg";
// import { getUniqueId } from "src/shared/utils";

const backAndForthAnimation = keyframes`
  0% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(2px);
  }
`;

const Message = styled.p`
  color: white;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  > img {
    animation: ${backAndForthAnimation} 0.5s linear 0s infinite;
    animation-direction: alternate;
    height: 30px;
    margin-right: 10px;
  }
  > a {
    margin-left: 7px;
  }
`;

const OAuthCallback: FC<RouteComponentProps> = ({ history, location }) => {
  const {
    loginAction: dispatchLoginAction,
    // pending: isPending,
    errors,
  } = useRedux<
    IRootState,
    { pending: boolean; errors: any },
    {
      loginAction(payload: LoginActionPayload);
    }
  >((state) => state.login, {
    loginAction,
  });

  useEffect(() => {
    const token = OAuthService.findTokenInHash(location.hash);
    OAuthService.processToken(token, (processedToken) => {
      dispatchLoginAction({
        token: processedToken,
        callbackFn() {
          history.push("/");
        },
      });
    });
  }, []);

  return (
    <Message>
      {!errors ? (
        <>
          <img src={StopwatchSvg} alt="loader" /> <span>Logging you in...</span>
        </>
      ) : (
        <>
          Error occured <Link to="/">Go to Home</Link>
        </>
      )}
    </Message>
  );
};

export default memo(OAuthCallback);
